import { Fragment, FunctionComponent } from 'react';
import cn from 'classnames';
import { PrintArea } from '@/types';
import { getHasSoftBoundary } from '@/model/printArea/getHasSoftBoundary';
import { useMultiSelectContext } from '@/components/draft/MultiSelectContext';
import { useSnapLinesPrintArea } from './hooks/useSnapLines';
import './PrintAreaRenderer.scss';

interface Props {
  printArea: PrintArea;
  isVisible: boolean;
}

export const PrintAreaRenderer: FunctionComponent<Props> = ({ printArea, isVisible }) => {
  const isSnapTarget = useSnapLinesPrintArea(printArea);
  const boundary = printArea.boundary;

  const hasMultiSelectedConfiguration = Boolean(useMultiSelectContext().configurationIds.length);
  const visible = isVisible || hasMultiSelectedConfiguration;

  return (
    <Fragment>
      <rect
        width={boundary.size.width}
        height={boundary.size.height}
        className={cn('print-area-zoom-test', {
          visible,
          snapped: isSnapTarget,
        })}
      />

      {getHasSoftBoundary(boundary) && (
        <path
          d={boundary.soft.content.svg.path.d}
          className={cn('soft-boundary-zoom-test', {
            visible,
          })}
        />
      )}
    </Fragment>
  );
};
